import { createFileRoute } from '@tanstack/react-router';

import { AssignmentDetail } from '@/features/Practice/AssignmentDetail';

export const Route = createFileRoute('/_student/courses/$batchId/practice/$category/$assessmentId')({
  component: AssignmentDetailRoute,
});

function AssignmentDetailRoute() {
  const { batchId, category, assessmentId } = Route.useParams();
  return <AssignmentDetail batchId={batchId} category={category} assessmentId={assessmentId} />;
}
